<ng-container *ngIf="control?.touched">
    <p class="error"> {{getErrorMessage()}} </p>
</ng-container>